import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-support-help-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  templateUrl: './support-help-dialog.component.html',
  styleUrl: './support-help-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SupportHelpDialogComponent {}
